import { PropsWithChildren } from 'react';
import './card.less';

type CardType = "widget" | "light"
type CardBorder = "all" | "no-top"

export default function Card(props: PropsWithChildren<{
  className?: string
  type?: CardType
  borders?: CardBorder
}>) {
  let className =  "card";
  if (props.className) {
    className += " " + props.className
  }
  let border = props.borders || "all"
  let type: CardType = props.type || "widget";
  className += " " + type;

  switch (border) {
    case "all": className += " all"; break;
    case "no-top": className += " no-top"; break;
  }

  return <div className={className}>
    {props.children}
  </div>
}